import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const CallToAction = () => {
  const { t } = useTranslation();
  const featureList = t('callToAction.featureList', { returnObjects: true });

  return (
    <section className="bg-gradient-to-br from-dblift-blue-dark to-dblift-blue-light py-20">
      <div className="container">
        <motion.div 
          className="rounded-2xl bg-white p-8 md:p-16 shadow-xl"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 
                className="text-3xl md:text-4xl font-bold text-dblift-blue-dark mb-6"
                dangerouslySetInnerHTML={{ __html: t('callToAction.title').replace('<span>', '<span class="text-dblift-orange">').replace('</span>', '</span>') }}
              >
              </h2>
              <p className="text-lg text-dblift-gray-dark mb-8">
                {t('callToAction.description')}
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/download" className="btn btn-primary">
                  {t('callToAction.downloadBtn')}
                </Link>
                <Link to="/getting-started" className="btn btn-outline">
                  {t('callToAction.startGuideBtn')}
                </Link>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="max-w-md">
                <div className="bg-dblift-gray-light p-6 md:p-8 rounded-xl">
                  <h3 className="text-xl font-bold text-dblift-blue-dark mb-4">{t('callToAction.keyFeatures')}</h3>
                  <ul className="space-y-4">
                    {featureList.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <svg className="h-6 w-6 text-dblift-orange mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;